import React, { useEffect } from "react";
import './ComboBox.css'

function ComboBox({
    setAttribute,
    optionsData,
    style,
    value,
    disabled,
    readOnly,
    placeholder,
    defaultValue,
    className = 'combobox',
    onBlur
}) {

    const handleSelectChange = (lookupChanged, id) => {
        lookupChanged(id)
    }

    // Extrai o primeiro valor das options
    const getFirstOptionValue = () => {
        if (!optionsData) return null;

        const children = Array.isArray(optionsData.props.children) 
            ? optionsData.props.children 
            : [optionsData.props.children];

        for (let child of children) {
            if (!child) continue;
            if (Array.isArray(child)) {
                for (let option of child) {
                    if (option && option.props && option.props.value != null) {
                        return option.props.value;
                    }
                }
            } else if (child.props && child.props.value != null) {
                return child.props.value;
            }
        }

        return null;
    }

    // Verifica se o value está nas opções
    let isValueInOptions = false;
    if (optionsData) {
        isValueInOptions = Array.isArray(optionsData.props.children) &&
            optionsData.props.children.some(child => {
                if (!child) return false;
                if (Array.isArray(child)) {
                    return child.some(option => String(option.props.value) === String(value));
                }
                return child.props && String(child.props.value) === String(value);
            });
    }

    // Se não tiver valor ou não estiver nas opções, seta o primeiro
    useEffect(() => {
        if ((!value || !isValueInOptions) && optionsData) {
            const firstValue = getFirstOptionValue();
            if (firstValue != null && setAttribute) {
                setAttribute(firstValue);
            }
        }
    }, [value, optionsData]);

    return (
        <select
            className={className}
            onChange={(e) => handleSelectChange(setAttribute, e.target.value)}
            value={isValueInOptions ? value : ''}
            disabled={disabled}
            readOnly={readOnly}
            style={{ ...style, cursor: 'pointer' }}
            defaultValue={isValueInOptions ? defaultValue : ''}
            onBlur={onBlur}
        >
            {placeholder &&
                <option value="" disabled hidden>
                    {placeholder || ""}
                </option>
            }
            {optionsData}
        </select>
    );
}

export default ComboBox;
